<template>

      <div class="d-flex flex-column" style="min-width:95vw; max-width:95vw">
        <v-sheet class="ma-1">
          <div class="d-flex flex-row">
            <v-text-field v-model="searchBy" label="Search by Affinity Id | Email | Username"
            prepend-inner-icon="mdi-magnify" variant="outlined" aria-label="Search by Affinity ID, Email, or Username" />
            <v-btn class="ml-2" @click="getAppUsersBy" icon="mdi-magnify" size="x-large" variant="text" aria-label="Search users" />   
            <v-btn v-if="systemStore.userDetail.isOrganizationAdmin" class="ml-15" @click="edit(emptyAppUser, true)" icon="mdi-account-plus" size="x-large" variant="text" aria-label="Add new user" />                
            <div style="width: 50%;"></div>
          </div>
        </v-sheet>
        <v-sheet class="ma-1">
          <v-card 
          variant="outlined"
          title="Member Lookup"
          flat>
          <template v-slot:text>
              <v-text-field v-model="search" label="Filter" prepend-inner-icon="mdi-filter-outline"
                  variant="outlined" single-line></v-text-field>
          </template>

          <v-data-table
            :items-per-page="-1" 
            :items-per-page-options="[5, 10, 25, 50, -1]"
            :headers="headers"
            :items="users" :search="search" item-key="id"
            role="table"
            aria-label="Member lookup data">

              <template v-slot:item.emailAddressVerified="{ item }">
                  <v-icon :icon="item.emailAddressVerified === true ? 'mdi-check' : 'mdi-close'"  />
              </template>
              
              <template v-slot:item.acceptedPortalTermsAndConditionsDate="{ item }">
                  <v-icon v-if="item.acceptedPortalTermsAndConditionsDate == null && item.userType === 'Partner'" icon='mdi-close'  />
                  <p v-if="item.acceptedPortalTermsAndConditionsDate != null && item.userType === 'Partner'"><v-icon icon='mdi-check'/>&nbsp;&nbsp;&nbsp;&nbsp;{{ $filters.toNiceDate(item.acceptedPortalTermsAndConditionsDate) }}</p>
                  <v-icon v-if="item.userType !== 'Partner'" icon='mdi-minus'  />
              </template>

              <template v-slot:item.isOrganizationAdmin="{ item }">
                  <v-icon :icon="item.isOrganizationAdmin === true ? 'mdi-check' : 'mdi-close'" />
              </template>

              <template v-slot:item.isLockedOut="{ item }">
                  <v-btn :icon="item.isLockedOut === true ? 'mdi-lock' : 'mdi-lock-open-variant-outline'" @click="toggleUserAccountState(item)"  variant="text"/>
              </template>

              <template v-slot:item.edit="{ item }">
                  <v-btn icon="mdi-account-edit" @click="edit(item, false)" variant="text" aria-label="Edit user" />
              </template>
              
              <template v-slot:item.impersonate="{ item }">
                    <v-btn icon="mdi-account-switch" @click="impersonateUser(item.username)" variant="text" aria-label="Impersonate user" />
              </template>
              
          </v-data-table>
        </v-card>  
        </v-sheet>
      </div>

      <div>
        <Transition name="modal">
          <div v-if="editShow" class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-header">
                  <h3 class="modal-title">{{editTitle}}</h3>
                  <div class="modal-actions">
                    <v-btn icon="mdi-check-bold" type="submit" form="edit-user-form" class="modal-save-button" size="x-small" variant="text" aria-label="Save user">
                      <v-icon>mdi-check-bold</v-icon>
                      <v-tooltip
                        activator="parent"
                        location="top"
                      >Save and Close</v-tooltip>
                    </v-btn>
                    <v-btn icon="mdi-close-thick" class="modal-cancel-button" @click="close" size="x-small" variant="text" aria-label="Cancel edit">
                      <v-icon>mdi-close-thick</v-icon>
                      <v-tooltip
                        activator="parent"
                        location="top"
                      >Cancel and Close</v-tooltip>
                    </v-btn>
                  </div>
                </div>
                <div class="modal-body" tabindex="0" role="region" aria-label="User edit form">
                  <v-form id="edit-user-form" @submit.prevent="saveUserAccount">
                      <v-text-field :rules="affinityRules" required :readonly="!isNewUser" :append-inner-icon="isNewUser ? '' : 'mdi-pencil-lock'" label="Affinity Id" type="number" v-model="editUser.organizationId" density="comfortable"></v-text-field>
                      <v-text-field :rules="emailRules" required :readonly="!isNewUser" :append-inner-icon="isNewUser ? '' : 'mdi-pencil-lock'" label="Email address" type="email" v-model="editUser.emailAddress" density="comfortable"></v-text-field>
                      <v-text-field :rules="firstNameRules" required label="First name" type="input" v-model="editUser.firstname" density="comfortable"></v-text-field>
                      <v-text-field :rules="lastNameRules" required label="Last name" type="input" v-model="editUser.lastname" density="comfortable"></v-text-field>
                      <v-select v-if="systemStore.userDetail.isOrganizationAdmin" :rules="userTypeRules" required :readonly="editUser.userType === 'Partner'" :append-inner-icon="editUser.userType === 'Partner' ? 'mdi-pencil-lock' : ''" :clearable="editUser.userType !== 'Partner'" :items="userTypes" v-model="editUser.userType" label="Select User Type" item-title="userType" item-value="userType"
                         variant="outlined" density="comfortable"></v-select>
                      <v-switch v-if="systemStore.userDetail.isOrganizationAdmin"
                        v-model="editUser.isOrganizationAdmin"
                        color="primary"
                        label="Admin"
                        density="comfortable"
                      ></v-switch>
                      <v-switch v-if="editUser.userType === 'Partner'"
                        v-model="editUser.preferredAutoRedemptionEmail"
                        color="primary"
                        label="Preferred Auto Redemption Email"
                        density="comfortable"
                      ></v-switch>
                      <v-select :rules="countryRules" required :readonly="!systemStore.userDetail.isOrganizationAdmin" :clearable="systemStore.userDetail.isOrganizationAdmin" :append-inner-icon="systemStore.userDetail.isOrganizationAdmin ? '' : 'mdi-pencil-lock'" :items="countries" v-model="editUser.country" label="Select Country" item-title="country" item-value="country"
                      variant="outlined" density="comfortable"></v-select>
                      <v-select :rules="languageRules" required :readonly="!systemStore.userDetail.isOrganizationAdmin" :clearable="systemStore.userDetail.isOrganizationAdmin" :append-inner-icon="systemStore.userDetail.isOrganizationAdmin ? '' : 'mdi-pencil-lock'" :items="languages" v-model="editUser.language" label="Select Language" item-title="language" item-value="language"
                      variant="outlined" density="comfortable"></v-select>
                      <div class="d-flex flex-row align-center">
                        <v-text-field
                          :model-value="editUser.isTotpEnabled ? 'Enabled' : 'Disabled'"
                          readonly
                          append-inner-icon="mdi-pencil-lock"
                          density="comfortable"
                          aria-label="MFA status"
                          class="flex-grow-1"
                        >
                          <template v-slot:label>
                            <span id="totp-enabled-label">MFA</span>
                          </template>
                        </v-text-field>
                        <v-btn
                          v-if="!isNewUser"
                          type="button"
                          class="ml-2 mb-6 flex-shrink-0"
                          variant="outlined"
                          prepend-icon="mdi-two-factor-authentication"
                          @click="resetTotpEnabled"
                          @keydown.enter="resetTotpEnabled"
                          @keydown.space.prevent="resetTotpEnabled"
                          aria-label="Reset MFA for this user"
                          tabindex="0"
                        >
                          Reset MFA
                        </v-btn>
                      </div>
                  </v-form>                  
                </div>

                <div class="modal-footer">
                  <slot name="footer">
  
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useUserStore } from '@/stores/user'
import { useCountryStore } from '@/stores/country'
import { useSystemStore } from '@/stores/system'
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'

const userStore = useUserStore()
const countryStore = useCountryStore()
const systemStore = useSystemStore()
const authStore = useAuthStore()
const router = useRouter();

const users = ref([])
const searchBy = ref('')
const search = ref('')

const editShow = ref(false)
const editTitle = ref('') 
let emptyAppUser = {}
const editUser = ref()

const countries = ref([])
const userTypes = ref([])
const languages = ref([])
const isNewUser = ref(false)

const headers = [
  { key: 'username', title: 'User Name'},
  { key: 'emailAddressVerified', title: 'Verified'},
  { key: 'acceptedPortalTermsAndConditionsDate', title: "Accepted T's & C's"},
  { key: 'firstname', title: 'First Name'},
  { key: 'lastname', title: 'Last Name'},
  { key: 'userType', title: 'User Type'},
  { key: 'isOrganizationAdmin', title: 'Admin'},
  { key: 'status', title: 'Status'},  
  { key: 'isLockedOut', title: 'Toggle Lock'},
  { key: 'edit', title: 'Edit'},
  { key: 'impersonate', title: 'Impersonate'}
]

const affinityRules = [ value => !!value || 'You must enter the Affinity Id.' ]
const emailRules = [ value => !!value || 'You must enter an email address.',
  value => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value) || 'You must enter an email address.'
 ]
const firstNameRules = [ value => !!value || 'You must enter a first name.' ]
const lastNameRules = [ value => !!value || 'You must enter a last name.' ]
const userTypeRules = [ value => !!value || 'You must enter the user type.']
const countryRules = [ value => !!value || 'You must enter the country.']
const languageRules = [ value => !!value || 'You must enter the language.']

onMounted(() => {
  countryStore.getEMEACountries().then(result => {
    countries.value = result.countries
  }).catch(error => {
    console.log('disti dashb get countries', error)
  })
  systemStore.getAllLanguages().then(result => {
    languages.value = result.languages
  }).catch(error => {
    console.log('disti dashb get languages', error)
  })
  userStore.getUserTypes().then(result => {
    userTypes.value = result.responseData.filter(item => item.userType !== 'Partner');    
  }).catch(error => {
    console.log('disti dashb get userTypes', error)
  })
  userStore.getEmptyAppUser().then(result => {
    emptyAppUser = result.responseData
  }).catch(error => {
    console.log('disti dashb get emptyAppUser', error)
  })
})

const getAppUsersBy = () => {  
  if (searchBy.value != '') {
    userStore.getAppUsersBy(searchBy.value).then(result => {
      if (result.hasData) {
        users.value = result.responseData
      }
    })    
  }
}

const toggleUserAccountState = (user) => {  
  userStore.toggleUserAccountState(user).then(result => {
    if (result.success === true) {
      getAppUsersBy()
    }
  })
}

const saveUserAccount = () => {  
  if (editUser.value.emailAddress === undefined || editUser.value.emailAddress === '' ||
    editUser.value.firstname === undefined || editUser.value.firstname === '' ||
    editUser.value.lastname === undefined || editUser.value.lastname === '' ||
    editUser.value.userType === undefined || editUser.value.userType === '' ||
    editUser.value.organizationId === undefined || editUser.value.organizationId === '' ||
    editUser.value.country == undefined || editUser.value.country == '' ||
    editUser.value.language === undefined || editUser.value.language === '') 
  {
    return
  }

  userStore.saveUserAccount(editUser.value).then(result => {
    if (result.success === true) {
      close()   
    }
  })    
}

const close = () => {  
  editShow.value = false
  getAppUsersBy()   
}

const edit = (user, isNew) => {
  isNewUser.value = isNew

  if (isNew === true) {
    editTitle.value = 'Add User'
    editUser.value = emptyAppUser
  }
  else {
    editTitle.value = 'Edit User'
    editUser.value = user
  }

  editShow.value = true
}

const resetTotpEnabled = () => {
  if (isNewUser.value || !editUser.value?.id) {
    return
  }

  userStore.resetTotpEnabled(editUser.value).then(result => {
    if (result.success === true) {
      editUser.value.isTotpEnabled = false
    }
  })
}

const impersonateUser = (username) => {
  authStore.impersonateUser(username).then(result => {
    const routeData = router.resolve({name: 'impersonateUser', params: {id: result}});
    window.open(routeData.href, '_blank');
  })
}

</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 500;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
}

.modal-container {
  width: 100%;
  max-height: min(80vh, 640px);
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.modal-header {
  display: flex;
  align-items: center;
  padding: 16px 24px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}

.modal-title {
  flex: 1;
}

.modal-actions {
  display: flex;
  align-items: center;
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px 30px 20px;
}

.modal-save-button {
  margin: 0px 10px;
}

.modal-cancel-button {
  margin: 0px 10px;
}

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>